import * as d3 from 'd3';
import { addToStack, getPositionInScene } from "../Util";
import { createNewItem } from "../canvasSlice";
import store from "../store";

let pts = [], x = undefined, y = undefined;

export const mouseDown = (e, scene) => {
    //const p = getPositionInScene(e.clientX, e.clientY);
    //pts.push([p[0], p[1]]);
}

export const mouseUp = (e, scene, datasets, renderer, undoStack) => {
    if (x !== undefined && y !== undefined) {
        let dist = Math.sqrt(Math.pow(x - pts[0][0], 2) + Math.pow(y - pts[0][1], 2));
        if (dist < 2 && pts.length > 2) {
            pts.push([pts[0][0], pts[0][1]]);
            finish(scene, datasets, renderer, undoStack);
        } else {
            pts.push([x, y]);
            updateUI();
        }
    } else {
        const p = getPositionInScene(e.clientX, e.clientY);
        pts.push([p[0], p[1]]);
    }
    d3.select("#selectionUI").select("#vertexPreview").style("visibility", "hidden");
}

export const updateUI = () => {
    let d = ["M", pts[0][0], pts[0][1]].join(" ");
    for (let i = 1; i < pts.length; i++) {
        let vx = pts[i][0], vy = pts[i][1];
        if (vx === pts[0][0] && vy === pts[0][1]) {
            d += "Z";
        } else {
            d += ["L", pts[i][0], pts[i][1]].join(" ");
        }
    }
    if (x !== undefined && y !== undefined)
        d += ["L", x, y].join(" ");
    d3.select("#polylineToolUI").style("visibility", "visible").style("fill", "none").attr("d", d);
}

export const mouseMove = (e, scene) => {
    if (pts.length === 0) return;
    let p = getPositionInScene(e.clientX, e.clientY), lp = pts[pts.length-1];
    if (e.shiftKey) {
        let angle = Math.atan2(p[1] - lp[1], p[0] - lp[0]) * 180 / Math.PI,
            angleR = Math.round(angle/45) * 45 * Math.PI/180, 
            dist = Math.sqrt(Math.pow(p[1] - lp[1], 2) + Math.pow(p[0] - lp[0], 2));
        x = lp[0] + Math.cos(angleR) * dist;
        y = lp[1] + Math.sin(angleR) * dist;
    } else {
        x = p[0];
        y = p[1];
    }
    let dist = Math.sqrt(Math.pow(x - pts[0][0], 2) + Math.pow(y - pts[0][1], 2));
    if (dist < 2 && pts.length > 2) {
        d3.select("#selectionUI").select("#vertexPreview").attr("x", pts[0][0] - 5).attr("y", pts[0][1] - 5)
            .attr("width", 10).attr("height", 10).style("visibility", "visible");
    } else {
        d3.select("#selectionUI").select("#vertexPreview").style("visibility", "hidden");
    }
    updateUI();
}

export const finish = (scene, datasets, renderer, undoStack) => {
    if (!pts || pts.length === 0) {
        return;
    }
    updateUI();
    d3.select("#polylineToolUI").style("visibility", "hidden");
    if (pts.length > 1) {
        addToStack(scene, datasets, undoStack);
        let r = scene.mark("path", {vertices: pts});
        store.dispatch(createNewItem(r.id));
        //store.dispatch(select([r.id]));
        renderer.render(scene);
    }
    pts = [];
    x = undefined;
    y = undefined;
}